import React from 'react'
import Headers from '../components/Header';
import Footer from '../Screen/Footer';

const ShippingPolicy = () => {
  return (
    <div>
      <Headers />
      <section style={{minHeight:'auto'}} className='container'>
        <h2 className='mb-3'>Shipping Policy</h2>
        <p className='mb-3'>The orders for the user are shipped through registered domestic courier companies and/or speed post only. Orders are shipped within 5 days from the date of the order and/or payment or as per the delivery date agreed at the time of order confirmation and delivering of the shipment, subject to courier company / post office norms. Platform Owner shall not be liable for any delay in delivery by the courier company / postal authority. Delivery of all orders will be made to the address provided by the buyer at the time of purchase. Delivery of our services will be confirmed on your email ID as specified at the time of registration. If there are any shipping cost(s) levied by the seller or the Platform Owner (as the case be), the same is not refundable.</p>
      </section>

      <Footer/>

    </div>
  )
}

export default ShippingPolicy